import React from 'react';
import {
  Modal,
  Form,
  Input,
  Checkbox,
  Button
} from 'antd';
const FormItem = Form.Item;

const SystemHubModalForm = Form.create()((props) => {
  const {
    title,
    hub,
    visible,
    onCancel,
    onSubmit,
    form
  } = props;
  const {getFieldDecorator} = form;
  return (<Modal visible={visible} title={title} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
      <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
      <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
        Lưu
      </Button>
    ]}>
    <Form layout="vertical">
      <FormItem >
        {getFieldDecorator('ID', {initialValue: hub.ID})(<span/>)}
      </FormItem>
      <FormItem label="Tên hub">
        {
          getFieldDecorator('Name', {
            rules: [
              {
                required: true,
                message: 'Phải nhập tên hub!'
              }
            ],
            initialValue: hub.Name
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Address">
        {
          getFieldDecorator('HubAddress', {
            rules: [
              {
                required: true,
                message: 'Phải nhập địa chỉ!'
              }
            ],
            initialValue: hub.HubAddress
          })(<Input placeholder=":6600"/>)
        }
      </FormItem>
      <FormItem label="Mô tả">
        {getFieldDecorator('Description', {initialValue: hub.Description})(<Input/>)}
      </FormItem>
      <FormItem>
        {
          getFieldDecorator('AutoStart', {
            initialValue: hub.AutoStart,
            valuePropName: 'checked'
          })(<Checkbox>Auto Start</Checkbox>)
        }
      </FormItem>
    </Form>
  </Modal>);
})

export default SystemHubModalForm



// WEBPACK FOOTER //
// ./src/components/SystemHubModalForm.js